import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	margin-right: 4px;
`;

export const InputContainer = styled.div<{ $fullWidth?: boolean }>`
	position: relative;
	display: flex;
	align-items: center;
	width: ${({ $fullWidth }) => ($fullWidth ? '100%' : '150px')};
`;

export const SearchIcon = styled.div`
	position: absolute;
	left: 12px;
	color: ${({ theme }) => theme.gray[600]};
	pointer-events: none;
	display: flex;
	align-items: center;
	z-index: 1;
`;

export const Input = styled.input`
	width: 100%;
	padding: 8px 12px 8px 40px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 16px;
	font-size: 14px;
	background-color: ${({ theme }) => theme.gray[0]};
	color: ${({ theme }) => theme.gray[1000]};
	transition: border-color 0.2s ease;
	font-family: 'Inter', sans-serif;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}

	&::placeholder {
		color: ${({ theme }) => theme.gray[400]};
	}
`;

export const ClearButton = styled.button`
	position: absolute;
	right: 8px;
	padding: 4px;
	border: none;
	background: none;
	color: ${({ theme }) => theme.gray[600]};
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;
	transition: background-color 0.2s ease, color 0.2s ease;
	z-index: 1;

	&:hover {
		background-color: ${({ theme }) => theme.gray[100]};
		color: ${({ theme }) => theme.gray[1000]};
	}

	&:focus-visible {
		outline: 2px solid ${({ theme }) => theme.blue[500]};
		outline-offset: 2px;
	}
`;

export const IconButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 16px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background: ${({ theme }) => theme.gray[0]};
	color: ${({ theme }) => theme.gray[600]};
	transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
	padding: 0;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
		color: ${({ theme }) => theme.gray[1000]};
	}
`;

export const Dropdown = styled.div<{ $iconOnly?: boolean }>`
	min-width: ${({ $iconOnly }) => ($iconOnly ? '320px' : '280px')};
	max-height: 400px;
	overflow-y: auto;
	background: ${({ theme }) => theme.gray[0]};
	border-radius: 8px;
	padding: 4px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	border: 1px solid ${({ theme }) => theme.gray[200]};
	z-index: 1000;
`;

export const DropdownSearch = styled.div`
	padding: 6px;
	padding-bottom: 8px;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
	margin-bottom: 4px;
`;

export const ResultsList = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ResultItem = styled.div<{ $highlighted?: boolean }>`
	padding: 8px 12px;
	border-radius: 6px;
	transition: background-color 0.1s ease;
	background: ${({ $highlighted, theme }) => ($highlighted ? theme.gray[100] : 'transparent')};
	cursor: default;

	&:hover {
		background: ${({ theme }) => theme.gray[100]};
	}
`;

export const ResultHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`;

export const ResultLabel = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	font-family: 'Inter', sans-serif;
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const SectionBadge = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 2px 6px;
	border-radius: 4px;
	background: ${({ theme }) => theme.gray[100]};
	font-size: 10px;
	color: ${({ theme }) => theme.gray[600]};
	font-family: 'Inter', sans-serif;
	text-transform: uppercase;
	letter-spacing: 0.3px;
	flex-shrink: 0;
`;

export const ResultContext = styled.div`
	font-size: 12px;
	color: ${({ theme }) => theme.gray[600]};
	font-family: 'Inter', sans-serif;
	margin-top: 4px;
	line-height: 1.4;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const EmptyState = styled.div`
	padding: 16px 12px;
	text-align: center;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 14px;
	font-family: 'Inter', sans-serif;
`;
